export const DELIVERY_FLOW = [
  "order_confirmed", "preparing", "waiting_for_driver", "driver_assigned",
  "driver_picked_up", "on_the_way", "arriving_soon", "customer_verified", "delivered",
];
export const PICKUP_FLOW = [
  "order_received", "preparing", "ready_for_pickup", "pickup_address_sent",
  "customer_on_the_way", "customer_has_arrived", "customer_verified", "order_picked_up",
];

export const STATUS_LABELS = {
  order_confirmed: "Order Confirmed",
  order_received: "Order Received",
  preparing: "Preparing Your Food",
  waiting_for_driver: "Waiting for Driver",
  driver_assigned: "Driver Assigned",
  driver_picked_up: "Driver Picked Up Your Order",
  on_the_way: "Driver On The Way",
  arriving_soon: "Arriving Soon",
  ready_for_pickup: "Ready for Pickup",
  pickup_address_sent: "Pickup Address Sent",
  customer_on_the_way: "Customer On The Way",
  customer_has_arrived: "Customer Has Arrived",
  customer_verified: "Customer Verified",
  delivered: "Delivered",
  order_picked_up: "Order Picked Up",
  cancelled: "Cancelled",
};

export const PAYMENT_LABELS = {
  unpaid: "Unpaid",
  awaiting_verification: "Awaiting Payment Verification",
  verified: "Payment Verified",
  rejected: "Payment Rejected",
  cash_due_delivery: "Cash Due at Delivery",
  cash_due_pickup: "Cash Due at Pickup",
};

export const ETA_PRESETS = [
  { label: "30 minutes", minutes: 30 },
  { label: "20 minutes", minutes: 20 },
  { label: "15 minutes", minutes: 15 },
  { label: "10 minutes", minutes: 10 },
  { label: "5 minutes", minutes: 5 },
  { label: "Arriving Now", minutes: 0 },
];

export function flowFor(type) {
  return type === "delivery" ? DELIVERY_FLOW : PICKUP_FLOW;
}
